import { createAction } from 'redux-actions';

// action types
export const SET_INITIAL_USER = 'SET_INITIAL_USER';
export const FLOW_USER_AUTHENTICATED = 'FLOW_USER_AUTHENTICATED';
export const SET_USER_AVATAR = 'SET_USER_AVATAR';

// actions
export const setInitialUser = createAction(SET_INITIAL_USER);
export const flowUserAuthenticated = createAction(FLOW_USER_AUTHENTICATED);
/**
 * @description Updates only the avatar, without touching the rest of the
 * user slice. Used so a slow/failed avatar fetch never delays or clobbers
 * name/email/phone hydration (see SET_INITIAL_USER).
 */
export const setUserAvatar = createAction(SET_USER_AVATAR);
